/**
 * @type {BD_CFG}
 */
const CONFIG = {
  isAuth: window.CFG?.isAuth ?? false,
  ajaxUrl: window.CFG?.ajaxUrl ?? "",
  nonce: window.CFG?.nonce ?? "",
  siteURL: window.CFG?.siteURL ?? "",
  restURL: window.CFG?.restURL ?? "",
  currentURL: window.CFG?.currentURL ?? "",
  welcomeURL: window.CFG?.welcomeURL ?? "",
  GP: window.CFG?.GP ?? 0,
  user: window.CFG?.user ?? {
    id: 0,
    avatar: "",
    nickname: "",
    email: "",
    userRole: [],
  },
  game_options: window.CFG?.game_options ?? {
    transition_between_building_block: "default-loader",
    go_to_next_when_time_runs_out: false,
    timer_config: window.CFG?.game_options?.timer_config ?? {
      is_enable_timer: false,
      timer_mode: "count_down",
      timer_limit: 0,
      is_timeout_code_different: false,
      timeout_code: "",
    },
    enable_submit_button_after_time_runs_out: false,
    modules: [],
    avatar_options: window.CFG?.game_options?.avatar_options ?? [],
    blindspot_show_after_building_block: 0,
    blindspot_close_after_building_block_post_game: 0,
    rating_type: "standard",
    building_block: {
      video: {
        video_disable_replay: false,
      },
      audio: {
        audio_disable_replay: false,
      },
    },
    story_mode: window.CFG?.game_options?.story_mode ?? false,
  },
  firebase: window.CFG?.firebase ?? {
    key: "",
    auth_domain: "",
    database_url: "",
    auth_token: "",
    team_code: "",
    environment: "",
  },
  siteSetup: window.CFG?.siteSetup ?? "default",
  sequences: window.CFG?.sequences ?? [],
  STTVersion: window.CFG?.STTVersion ?? false,
  teamconnector: window.CFG?.teamconnector ?? {
    id: 0,
    members: [],
    categories: [],
    timer: 0,
  },
  user_progress: window.CFG?.user_progress ?? {
    answer_variables: [],
    current_block_id: 0,
    current_block_type: false,
    history: [],
    team_code: false,
    is_leader: false,
    is_timeout: false,
  },
  building_blocks: window.CFG?.building_blocks,
  weather_widget: window.CFG?.weather_widget ?? {
    location_name: "Amsterdam",
    weather_animations: [],
  },
  strings: window.CFG?.strings ?? {
    removedFromTeam: "",
    playerLeft: "{player} left the game",
    confirmLeave: "Are you sure want to leave the team?",
  },
};

export default CONFIG;
